import type { ReactNode } from 'react';
import React, { createContext, useCallback, useEffect, useRef } from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../labelling-v2/components/stage-scope/hooks';
import useStage from './hooks/use-stage';
const Container = styled('div', {
  position: 'relative',
  height: '100%',
  width: '100%'
});
type ContentCanvasContextT = {
  getCanvasContext: () => CanvasRenderingContext2D | undefined | null;
};
export const ContentCanvasContext = createContext<ContentCanvasContextT>({
  getCanvasContext: () => null
});
type PropsT = {
  children?: ReactNode;
};
export const ContentCanvasProvider = ({
  children
}: PropsT) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const {
    getStageDimension
  } = useStage();
  const {
    imageSettingsAtom
  } = useStageAtoms();
  const imageSettings = useAtomValue(imageSettingsAtom);
  const getCanvasContext = useCallback(() => canvasRef.current?.getContext('2d', {
    willReadFrequently: true
  }), []);
  useEffect(() => {
    const canvas = canvasRef.current;
    const stageDimension = getStageDimension();
    const {
      brightness,
      contrast
    } = imageSettings;
    if (stageDimension && canvas && (canvas.width !== stageDimension[0] || canvas.height !== stageDimension[1])) {
      canvas.width = stageDimension[0];
      canvas.height = stageDimension[1];
    }
    if (canvas) {
      canvas.style.filter = `brightness(${brightness}%) contrast(${contrast}%)`;
    }
  }, [imageSettings, getStageDimension]);
  return <Container>
      <canvas ref={canvasRef} style={{
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      cursor: 'inherit'
    }} />
      <ContentCanvasContext.Provider value={{
      getCanvasContext
    }}>
        {children}
      </ContentCanvasContext.Provider>
    </Container>;
};